import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {auth} from '../firebaseApp';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';

import { Link } from 'react-router-dom';
import * as routes from '../Constants/routes';
import AuthUserContext from '../Session/AuthUserContext';

import GoogleAnalytics from '../Components/GoogleAnalytics';

const styles = {
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};

class AppHeader extends Component {

  constructor(props) {
    super(props);
    this.state = { anchorEl: null, };
  }
  
  handleMenuClick = event => {
    this.setState({anchorEl: event.currentTarget });
  }

  handleMenuClose = () => {
    this.setState({anchorEl: null });
  }

  handleSignOut = () => {
    auth.signOut();
    GoogleAnalytics.event(
      GoogleAnalytics.CATEGORY.user,
    GoogleAnalytics.CAAZAM_EVENTS.signOut);
    this.setState({anchorEl: null });
  }

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;

    return (
      <AuthUserContext.Consumer>
        {authUser =>
          < div className={classes.root}>
            <AppBar position="fixed">
              <Toolbar>
                {authUser &&
                  <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.handleMenuClick}>
                    <MenuIcon />
                  </IconButton>
                }
                <Menu id="simple-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.handleMenuClose}
                >
                  <MenuItem component={Link} to={routes.HOME} onClick={this.handleMenuClose}>Photos of Me</MenuItem>
                  <MenuItem component={Link} to={routes.PROFILE} onClick={this.handleMenuClose}>My Profile</MenuItem>
                  <MenuItem onClick={this.handleSignOut}>Sign Out</MenuItem>
                </Menu>
                <Typography variant="title" color="inherit" className={classes.flex}>
                  Caazam!
          </Typography>
                {!authUser && <Button component={Link} to={routes.SIGN_IN} color="inherit">Login</Button>}
              </Toolbar>
            </AppBar>
          </div>
        }
      </AuthUserContext.Consumer >

    );
  }
}

AppHeader.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppHeader);


// WEBPACK FOOTER //
// ./src/CaazamApp/AppHeader.js